import { render, staticRenderFns } from "./IrReconciliation.vue?vue&type=template&id=1f607174&"
import script from "./IrReconciliation.vue?vue&type=script&lang=js&"
export * from "./IrReconciliation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports